import React from "react";
import { HashLink } from 'react-router-hash-link';

const SectionTitle = ({ title, titleBtn, span, linkPath,color}) => {

  return (
    <div className="section-title">
      <div className="section-title-left">
        <h3 className={`section-name ${color}`}>
          {title}
          <span>{span}</span>
        </h3>
      </div>
      <div className="section-title-right">
        <HashLink to={`${linkPath}/#header`} className={`section-title-btn ${color}`}>
          {titleBtn}
        </HashLink>
      </div>
    </div>
  );
};

export default SectionTitle;
